module.exports = __webpack_public_path__ + "img/news1.5bc855dd.png";